import React, { ReactElement } from 'react';
import {
    Card,
    CardHeader,
    Avatar,
    CardContent,
    Typography,
    CardMedia,
    makeStyles,
    CardActions,
    Button,
} from '@material-ui/core';
import profileImage from './profileImage.jpg';

interface Props {
    text: string;
    imageUrl: string;
    date: string;
    linkedinUrl: string;
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: 400,
        [theme.breakpoints.down('sm')]: {
            width: 300,
        },
    },
    media: {
        height: 200,
    },
}));

function SocialFeedCard({ date, text, imageUrl, linkedinUrl }: Props): ReactElement<Props> {
    const classes = useStyles();

    return (
        <Card className={classes.root}>
            <CardHeader
                title="London Insulation Services"
                subheader={date}
                avatar={<Avatar alt="London Insulation Services" src={profileImage} />}
            />
            <CardContent>
                <Typography variant="body2" color="textSecondary" component="p">
                    {text}
                </Typography>
            </CardContent>
            <CardMedia className={classes.media} image={imageUrl} />
            <CardActions disableSpacing>
                <Button onClick={(): Window | null => window.open(linkedinUrl, '_blank')} size="small" color="primary">
                    Read more
                </Button>
            </CardActions>
        </Card>
    );
}

export default SocialFeedCard;
